// ** Redux Imports
import { Dispatch } from 'redux'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from '../../../services/ApiService'

interface DataParams {
    q?: string | null
    dates?: Date[] | null
    status: string | null
}

//interface Redux {
//    getState: any
//    dispatch: Dispatch<any>
//}

// ** Fetch Channels
export const fetchAllAvailableChannels = createAsyncThunk('appChannel/fetchAllAvailableChannels', async (params: DataParams) => {
    const response = await axios.get('channel/GetAllAvailableChannels', {
        params
    })

    return response;
})

//export const deleteChannel = createAsyncThunk(
//    'appChannel/deleteData',
//    async (id: number | string, { getState, dispatch }: Redux) => {
//        const response = await axios.delete('/apps/channel/delete', {
//            data: id
//        })
//        await dispatch(deleteSelectedChannel(getState().channel.params))

//        return response.data
//    }
//)

export const appChannelSlice = createSlice({
    name: 'appChannel',
    initialState: {
        data: [],
        total: 1,
        params: {},
        allData: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchAllAvailableChannels.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
    }
})

export default appChannelSlice.reducer
